import { BaseModel, Column, Model } from 'scf-graphql-model'

@Model('oauth', ['oauthRequired'])
export class OAuth extends BaseModel {
  @Column()
  mandator: string | undefined;
  @Column()
  oauthUrl: string | undefined;
}
